import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, BehaviorSubject} from 'rxjs';
import {PropertiesService} from './properties.service';
import { ConfigurazioneCaptcha} from "../interfaces/utilities";



@Injectable({
	providedIn: 'root'
})
export class ConfigurationService {
    
    configuration = new BehaviorSubject<ConfigurazioneCaptcha>(null);
	private _subCurrent = this.configuration.subscribe(data=>{
		if(data !== null){
			return data;
		}
	});

    constructor(private http: HttpClient, private propService: PropertiesService) { }

    getCaptchaConfiguration(): Observable<any> {
		return this.http.get<any>(this.propService.getProp('apiPrefix') + '/api/Public/Servizi/ConfigurazioneCaptcha');
    }
}